import React from 'react';

export interface InfoItem {
  label: string;
  value: React.ReactNode;
  icon?: string;
  valueColor?: string;
}

interface InfoGridProps {
  title?: string;
  items: InfoItem[];
  columns?: number;
  /** Accent colour for the top border of each card */
  accentColor?: string;
  style?: React.CSSProperties;
}

/**
 * A grid of info cards — used in ReviewSign (Your Information), GoLiveC1 (Summary cards), etc.
 * Each card has a coloured top border, label, icon, and value.
 */
const InfoGrid: React.FC<InfoGridProps> = ({
  title,
  items,
  columns = 3,
  accentColor = '#1B3A6B',
  style,
}) => (
  <div style={{
    background: '#fff',
    border: '1.5px solid #E2E8F0',
    borderRadius: 16,
    padding: '20px 24px',
    marginBottom: 16,
    boxShadow: '0 2px 12px rgba(27,58,107,0.06)',
    ...style,
  }}>
    {title && (
      <h3 style={{
        margin: '0 0 16px',
        fontSize: 14, fontWeight: 700,
        color: '#1B3A6B',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
      }}>
        {title}
      </h3>
    )}
    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: 12 }} className="info-grid__cards">
      {items.map((item) => (
        <div key={String(item.label)} style={{
          background: '#F8FAFC',
          border: '1.5px solid #E2E8F0',
          borderTop: `3px solid ${accentColor}`,
          borderRadius: 12,
          padding: '16px 18px',
        }}>
          <span style={{
            fontSize: 11, fontWeight: 700, color: '#64748B',
            textTransform: 'uppercase', letterSpacing: '0.07em',
            display: 'block', marginBottom: 8,
          }}>{item.label}</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {item.icon && <span style={{ fontSize: 18 }}>{item.icon}</span>}
            <span style={{
              fontSize: 15, fontWeight: 700,
              color: item.valueColor || '#1B3A6B',
              lineHeight: 1.3, wordBreak: 'break-word',
            }}>{item.value}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default InfoGrid;
